import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {SolicitudesService} from '../../services/solicitudes.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';

@Component({
  selector: 'app-validar-email-presol',
  templateUrl: './validar-email-presol.component.html',
  styleUrls: ['./validar-email-presol.component.css'],
  providers: [SolicitudesService]
})
export class ValidarEmailPresolComponent implements OnInit {
  public status: any;
  public message: string;
  public code: string;
  public clase: string;

  constructor(
    private solicitudesService: SolicitudesService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.code = '';
    this.status = 'null';
    this.clase = 'bg-secondary';
  }

  ngOnInit() {
    this.message = 'Validando correo electrónico...';
    this.getParams();
  }

  getParams() {
    this.route.params.subscribe(params => {
      this.code = params.code;
      this.validarEmail();
    });
  }

  openAlert(title, text, action, color, direccion = null): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action,
        color
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (direccion === null) {
        console.log(result);
      } else {
        this.router.navigate([direccion]);
      }
    });

   }


  validarEmail(){
    this.solicitudesService.validarEmailPresolicitud(this.code).subscribe(response => {
      this.message = response.message;
      if (response.status){
        this.status = true;
        this.clase = 'bg-success ';
        this.openAlert('Correo validado correctamente', response.message, 'Cerrar', 'primary', '/login');
      }else{
        this.status = false;
        this.clase = 'bg-danger';
      }
    }, error => {
      this.message = 'No se pudo procesar su solicitud en este momento [500]';
      this.clase = 'bg-danger';
      this.status = false;
    });
  }

}
